import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Loader2, Lock } from "lucide-react";
import { PublicShell, PublicMessage, PublicError } from "@/components/PublicShell";
import { BookingForm, MediadatenLink } from "@/pages/BookingPage";

export default function OpenBookingPage() {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  useEffect(() => { api.get("/public/booking-open").then((r) => setInfo(r.data)).catch((e) => setError(apiError(e.response?.data?.detail))); }, []);
  const until = info?.deadline ? info.deadline.split("-").reverse().join(".") : "";
  return (
    <PublicShell wide>
      <div data-testid="open-booking-page">
        {error && <PublicError text={error} testid="open-booking-error" />}
        {!error && !info && <div className="py-10 text-center text-slate-400"><Loader2 className="animate-spin mx-auto" /></div>}
        {done && <PublicMessage title="Vielen Dank für Ihre Buchung!" text="Ihre Buchung liegt uns vor und wird von der Redaktion geprüft. Sie erhalten in Kürze eine Eingangsbestätigung und anschließend unsere Rückmeldung per E-Mail." testid="open-booking-done" />}
        {info && !done && info.state === "closed" && <><PublicMessage icon={Lock} tone="text-amber-500" title="Buchung derzeit nicht möglich" text="Für die aktuelle Ausgabe ist der Buchungszeitraum abgelaufen. Bitte melden Sie sich direkt bei uns – wir informieren Sie gerne über die nächste Ausgabe." testid="open-booking-closed" /><div className="text-center"><MediadatenLink /></div></>}
        {info && !done && info.state === "open" && (
          <>
            <div className="flex flex-wrap items-start justify-between gap-2"><h1 className="font-display text-2xl font-bold text-slate-900" data-testid="open-booking-title">Anzeige buchen – {info.issue}</h1><MediadatenLink /></div>
            <p className="text-sm text-slate-500 mt-1 mb-6">Bitte wählen Sie Ihr Wunschformat und geben Sie anschließend Ihre Kontaktdaten an.{until ? ` Buchung möglich bis ${until}.` : ""}</p>
            <BookingForm info={info} url="/public/booking-open" onDone={() => setDone(true)} />
          </>
        )}
      </div>
    </PublicShell>
  );
}
